// 空气柜
export default [{ // 绑定成员
  path: '/airTank/deviceBindPeople',
  name: 'airTank.deviceBindPeople',
  component: resolve => require(['@/views/airTank/deviceBindPeople.vue'], resolve),
  meta: {
    isLoginAuthority: true // 需要登录权限才能访问
  }
}]


// WEBPACK FOOTER //
// ./src/router/airTank/airTank.js